export const LOCALSTORAGE_KEYS = {
  SAVED_CREDENTIALS: "__plugzio_user_credentials__",
  GUEST_ACTIVATION: "__guest-activation__",
  GUEST_ACTIVE_SESSION_IDS: "__guest-active-session-ids___",
  GUEST_ACTIVATION_ERROR: "__guest-activation-error__",
};
